import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { ContaEditarComponent } from "./conta-editar.component"; 
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { ContaEditarRoutingModule } from "./conta-editar-routing.module";
import { MessagesModule } from 'primeng/messages';
import { ProgressSpinnerModule } from "primeng/progressspinner";

@NgModule({
    imports: [
        CommonModule,            
        ContaEditarRoutingModule,
        FormsModule,
        ButtonModule,
        InputTextModule,
        DropdownModule,
        MessagesModule,
        ProgressSpinnerModule
    ],
    declarations: [ContaEditarComponent]
})
export class ContaEditarModule { }
